export default __webpack_public_path__ + "static/media/Card@1x.f14126a2.png";